import useComponentDidUnmount from 'App/components/hooks/useComponentDidUnmount';
import { SlideFade } from '@upsales/components/animations';
import bemClass from '@upsales/components/Utils/bemClass';
import { Icon, Text } from '@upsales/components';
import React, { useRef, useState } from 'react';
import T from 'Components/Helpers/translate';

import './SignalsToggle.scss';

type SignalsToggleProps = {
	enabled: boolean;
	onToggle: () => void;
};

const SignalsToggle: React.FC<SignalsToggleProps> = ({ enabled, onToggle }) => {
	const [showInfoBox, setShowInfoBox] = useState<boolean>(false);
	const classes = new bemClass('SignalsToggle');

	const [isEnabled, setIsEnabled] = useState<boolean>(false);

	const infoBoxRef = useRef<NodeJS.Timeout | null>(null);

	useComponentDidUnmount(() => {
		if (infoBoxRef.current) {
			clearTimeout(infoBoxRef.current);
		}
	});

	const lang = {
		title: T('account.signals.toggle.confirmTitle'),
		text: T('account.signals.toggle.confirmText'),
		removedTitle: T('account.signals.toggle.removedTitle'),
		removedText: T('account.signals.toggle.removedText')
	};

	const onClick = () => {
		setShowInfoBox(true);
		setIsEnabled(enabled);
		infoBoxRef.current = setTimeout(() => {
			setShowInfoBox(false);
		}, 4000);
		onToggle();
	};

	return (
		<div className={classes.mod({ enabled }).b()} onClick={onClick}>
			{enabled ? (
				<div className={classes.elem('icon-background').b()}>
					<Icon name="rss" color="green" />
				</div>
			) : (
				<Icon name="rss" color="grey-10" />
			)}

			<SlideFade visible={showInfoBox} bounce direction="top" speed="slow">
				<div id="info-box">
					<Icon name="check" />
					<span>
						<Text align="center" size="lg" color="bright-blue">
							{isEnabled ? lang.removedTitle : lang.title}
						</Text>
						<Text align="center" size="md" color="bright-blue">
							{isEnabled ? lang.removedText : lang.text}
						</Text>
					</span>
				</div>
			</SlideFade>
		</div>
	);
};

export default SignalsToggle;
